(function() {
  const customerTags = window.customerTags || [];
  const isWholesale = customerTags.some(tag => 
    tag.toLowerCase().includes('wholesale') || 
    tag.toLowerCase().includes('b2b')
  );

  if (isWholesale) {
    const bannerLinks = document.querySelectorAll('.black-friday-link');
    
    bannerLinks.forEach(link => {
      const currentUrl = link.getAttribute('href');
      
      if (currentUrl && currentUrl.includes('black-friday-cyber-monday-retail-sales-event')) {
        const wholesaleUrl = currentUrl.replace('black-friday-cyber-monday-retail-sales-event', 'black-friday-cyber-monday-wholesale-event');
        link.setAttribute('href', wholesaleUrl);
      }
    });
  }
})();
